import { Fragment } from 'react';
import { CustomerMap, updateCustomerMap } from '../../../../../store/CustomerMap';
import { DetailPanelParams } from '../../../../Compounds/DetailPanel/DetailPanel';
import { DetailViewCard } from '../../../../Compounds/CardWithTitle';
import { DetailPanelContainer } from '../../../../Compounds/DetailPanel/DetailPanelContainer';
import { EditFieldType } from '../../../../Compounds/DetailPanel/LabelValueField';
import { EntityType } from '../../../../../store/Search';

const SALESFORCE_URL = process.env.REACT_APP_SALESFORCE_INSTANCE_URL;

export interface CustomerMapDetailsParams {
  data: CustomerMap;
}

export const mapSections = (data: CustomerMap): DetailPanelParams[] => [
  {
    data,
    canEdit: [
      {
        field: 'sfdcCustomerUid',
        type: EditFieldType.SEARCHBOX,
        mapType: EntityType.CUSTOMER
      }
    ],
    fieldMap: {
      sfdcCustomerUid: 'Salesforce Customer',
      customerName: 'RPM Customer',
      copySfdcCustomerUid: 'Salesforce UID',
      sfdcUltimateParentAccountName: 'Ultimate Parent',
      customerId: 'RPM Customer ID'
    },
    order: ['sfdcCustomerUid', 'customerName', 'copySfdcCustomerUid', 'customerId', 'sfdcUltimateParentAccountName'],
    links: [
      {
        field: 'sfdcCustomerUid',
        link: null,
        externalLink: `${SALESFORCE_URL}/lightning/r/Account/${data.sfdcCustomerSfId}/view`,
        external: true
      },
      {
        field: 'customerName',
        link: null,
        externalLink: `${process.env.REACT_APP_RPM_URL}/rpm/Page/Customer.aspx?Item=${data.customerId}`,
        external: true
      },
      {
        field: 'sfdcUltimateParentAccountName',
        link: null,
        externalLink: `${SALESFORCE_URL}/lightning/r/Account/${data.sfdcUltimateParentAccountSfId}/view`,
        external: true
      }
    ],
    associationNameFields: {
      sfdcCustomerUid: 'sfdcCustomerName',
      copySfdcCustomerUid: 'sfdcCustomerUid'
    }
  }
];

export const CustomerMapDetails = ({ data }: CustomerMapDetailsParams) => {
  const handleSave = (update: CustomerMap) => updateCustomerMap(update);

  return (
    <Fragment>
      <div
        className="space-y-4 min-h-[80vh]"
        data-testid="customer-map-details-drawer">
        <DetailViewCard
          enableCollapse={false}
          key="customer-map-detail-card"
          title="Info">
          <div
            data-testid="customer-map-detail-card"
            className="min-h-[15rem]">
            <DetailPanelContainer
              data={mapSections(data)}
              saveAction={(d) => handleSave(d as CustomerMap)}
            />
          </div>
        </DetailViewCard>
      </div>
    </Fragment>
  );
};
